import { RequestBuilder } from '../request_builder'

export class NotificationsRequestBuilder extends RequestBuilder {
  constructor (serverUrl) {
    super(serverUrl)
    this.segment = 'notifications'
  }

  loadUnread (accountID) {
    this.filters.push(accountID)
    this.filters.push('list')
    this.filters.push('new')
    return this
  }

  markRead (accountID) {
    this.filters.push(accountID)
    this.filters.push('read')
    return this
  }

  sse (accountID) {
    this.filters.push(accountID)
    this.filters.push('sse')
    return this
  }
}



// WEBPACK FOOTER //
// ./src/js/builders/request_builder/modules/notifications_request_builder.js